export const SET_SWATCH_COLOR_NAME = "SET_SWATCH_COLOR_NAME"
export const SET_SELECTED_PRODUCTS_DATA = "SET_SELECTED_PRODUCTS_DATA"
export const SET_INIT_SELECTED_PRODUCTS_DATA = "SET_INIT_SELECTED_PRODUCTS_DATA"
export const SET_INVENTORY_DATA = "SET_INVENTORY_DATA"
export const SET_INVENTORY_STATUS = "SET_INVENTORY_STATUS"
export const SET_PROJECTION_DATA = "SET_PROJECTION_DATA"
